<template>
  <v-list-group
    :group="group"
    :prepend-icon="item.icon"
    :sub-group="subGroup"
    :active-class="ifHoover === true ? 'primary' : ''"
    append-icon="mdi-menu-down"
    :dark="menu_mode === 'dark'"
    :color="menu_mode === 'dark' ? 'white' : 'red'"
  >
    <template v-slot:activator>
      <v-list-item-icon
        v-if="text"
        class="v-list-item__icon--text"
        v-text="computedText"
      />

      <v-list-item-avatar
        v-else-if="item.avatar"
        class="align-self-center"
        color="grey"
      >
        <v-img :src="item.image" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="item.title" />
        <v-list-item-subtitle v-if="item.subtitle !== undefined" class="success--text font-weight-bold" v-text="item.subtitle" />
        <v-list-item-subtitle v-if="item.secondarySubtitle !== undefined" class="success--text font-weight-bold text-wrap" v-text="item.secondarySubtitle" />
      </v-list-item-content>
    </template>

    <template v-for="(child, i) in children">
      <base-item-sub-group
        v-if="child.children"
        :key="`sub-group-${i}`"
        :item="child"
      />

      <base-item v-else :style="style" :key="`item-${i}`" :item="child" text />
    </template>
  </v-list-group>
</template>

<script>
// Utilities
import kebabCase from "lodash/kebabCase";

export default {
  name: "ItemGroup",

  inheritAttrs: false,

  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    ifHoover: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    style() {
      return {
        backgroundColor: this.hexToRgb(window.systemData.THEME.menu_color),
      };
    },
    menu_mode() {
      return window.systemData.THEME.menu_mode;
    },
    children() {
      return this.item.children;
      return this.item.children.map((item) => ({
        ...item,
        to: !item.to ? undefined : `${this.item.group}/${item.to}`,
      }));
    },
    computedText() {
      if (!this.item || !this.item.title) return "";

      let text = "";

      this.item.title.split(" ").forEach((val) => {
        text += val.substring(0, 1);
      });

      return text;
    },
    group() {
      return this.genGroup(this.item.children);
    },
  },

  methods: {
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? "rgba(" +
            parseInt(result[1], 16) +
            ", " +
            parseInt(result[2], 16) +
            ", " +
            parseInt(result[3], 16) +
            ", .8), rgba(" +
            parseInt(result[1], 16) +
            ", " +
            parseInt(result[2], 16) +
            ", " +
            parseInt(result[3], 16) +
            ", .8)"
        : null;
    },
    genGroup(children) {
      return children
        .filter((item) => item.to)
        .map((item) => {
          const parent = item.group || this.item.group;
          let group = `${parent}/${kebabCase(item.to)}`;

          if (item.children) {
            group = `${group}|${this.genGroup(item.children)}`;
          }

          return group;
        })
        .join("|");
    },
  },
};
</script>

<style>
.v-list-group__activator p {
  margin-bottom: 0;
}
:not(.profile-menu) > .v-list-group__header.v-list-item--active {
  background-color: grey;
}
.profile-menu > .v-list-group__header.v-list-item--active {
  color: black !important;
  background-color: transparent !important;
}
.v-list-group__items {
  background-color: transparent;
  border-radius: 5px;
}
span.logo-mini {
  width: 40px !important;
  margin-left: 0px !important;
}
.v-list-item__icon {
  /* margin-right: 6px; */
  margin-right: 5px !important;
  margin-left: 0px !important;
}

:not(.v-navigation-drawer--is-mouseover)
  .v-application--is-ltr
  .v-list-item__avatar:first-child {
  margin-right: 0px !important;
}
:not(.logo-container) .v-list-item__content {
  margin-left: 10px !important;
}
.logo-container .v-list-item__content {
  margin-left: 0px !important;
}
</style>
